import * as React from 'react';
import { AvatarComponent } from 'ui';
import { jerseyOrLabel } from 'shared';
import { getImageFullUrl } from 'reporting/helpers';

export interface CellAvatarProps {
    avatarSrc: string;
    firstInitial?: string;
    secondInitial?: string;
    jersey?: string;
}

export const CellAvatarComponent: React.FC<CellAvatarProps> = (props) => {
    const { avatarSrc, firstInitial, secondInitial, jersey } = props;

    const initials = jerseyOrLabel(jersey, firstInitial && secondInitial ? firstInitial + secondInitial : undefined);

    return (
        // the initials are rendered as a div so they require a different 'top' value for alignment compared to an img
        <div className="avatar-table-cell" data-testid="avatar" style={{ top: avatarSrc.length > 0 ? '7px' : '4px' }}>
            <div style={{ border: '2px solid var(--sys-on-primary)', borderRadius: '50%' }}>
                <AvatarComponent imgURL={getImageFullUrl(avatarSrc)} size="sm" rounded initials={initials} />
            </div>
        </div>
    );
};
